module.exports = __webpack_public_path__ + "static/media/cal.e1ea0fc7.png";